var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "team" },
    [
      _c(
        "content-header",
        [
          _c(
            "content-header-title",
            { attrs: { slot: "header-left" }, slot: "header-left" },
            [_c("span", [_vm._v(_vm._s(_vm.$t("planHome.JNCP")))])]
          ),
          _vm.__userData.userType < 2
            ? _c(
                "el-button",
                {
                  attrs: {
                    slot: "header-right",
                    type: "primary",
                    size: "small",
                  },
                  on: { click: _vm.goCreateExercise },
                  slot: "header-right",
                },
                [_vm._v(" " + _vm._s(_vm.$t("planHome.XJLX")))]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("team-seach", {
            ref: "planSeach",
            attrs: { currentLayout: _vm.currentLayout },
            on: { changeLayout: _vm.changeLayout },
          }),
          _c("list-box", {
            ref: "listBox",
            attrs: { currentLayout: _vm.currentLayout },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }